import moment from 'moment';

function formatNumber(value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}

const copyToClipboard = (text, withText = false) => {
  let textField = document.createElement('textarea');
  textField.innerHTML = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};

function handleCopyMessageToBuffer(title, quote_id) {
  let text = `${title}
https://www.geograftour.com/geoclient/${quote_id}/`;
  copyToClipboard(text);
}

export function createMessageWithLink(title, quote_id) {
  let text = `${title}
https://www.geograftour.com/geoclient/${quote_id}/`;

  return text;
}

export function createMessageWithText(tours, title, quote_id) {
  let text = `${title}

${tours.map(
  (tour) =>
    `${moment(tour.checkin, 'YYYY-MM-DD').format('DD.MM.YYYY')}, ${
      tour.nights
    }н, ${tour.name}, ${tour.board}, ${
      tour.manager_data && tour.manager_data.initial_price
        ? formatNumber(parseInt(tour.manager_data.initial_price))
        : formatNumber(parseInt(tour.initial_price))
    } ${tour.currency}`
).join(`

`)}`;
  return text;
}

export function createMessageWithLinkAndText(tours, title, quote_id) {
  let text = `${title}
https://www.geograftour.com/geoclient/${quote_id}/

${tours.map(
  (tour) =>
    `${moment(tour.checkin, 'YYYY-MM-DD').format('DD.MM.YYYY')}, ${
      tour.nights
    }н, ${tour.name}, ${tour.board}, ${
      tour.manager_data && tour.manager_data.initial_price
        ? formatNumber(parseInt(tour.manager_data.initial_price))
        : formatNumber(parseInt(tour.initial_price))
    } ${tour.currency}`
).join(`

`)}`;
  return text;
}

export function createMessageWithLinkTextAndIcons(tours, title, quote_id) {
  let text = `${title}
https://www.geograftour.com/geoclient/${quote_id}/

${tours.map(
  (tour) =>
    `📅 ${moment(tour.checkin, 'YYYY-MM-DD').format('DD.MM.YYYY')} 
🌙 ${tour.nights} ночей 
🏠 ${tour.name}*
🍴 ${tour.board} 
🏷 ${
      tour.manager_data && tour.manager_data.initial_price
        ? formatNumber(parseInt(tour.manager_data.initial_price))
        : formatNumber(parseInt(tour.initial_price))
    } ${tour.currency}`
).join(`

`)}`;
  return text;
}

export function handleShareVK(title, quote_id) {
  let url = `https://geograftour.com/geoclient/${quote_id}/`;
  let image = `https://geograftour.com/static/index/img/quote_vk.jpg`;

  window.open(
    `https://vk.com/share.php?url=${url}&title=${encodeURIComponent(
      title
    )}&description=descriptionofquote&image=${image}&noparse=true`
  );
}

export function handleShareWhatsApp(title, quote_id) {
  window.open(
    `whatsapp://send?text=${encodeURIComponent(
      createMessageWithLink(title, quote_id)
    )}&phone=&abid=`
  );
}

export function handleShareTelegram(title, quote_id) {
  let url = `https://geograftour.com/geoclient/${quote_id}/`;
  window.open(
    `https://t.me/share/url?url=${url}&text=${encodeURIComponent(
      createMessageWithLink(title, quote_id)
    )}`
  );
}
